import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { FileInput } from '@hivebrite/design-system/Inputs';

import shouldDisplayError from 'hb-react/shared/components/formik/utils/shouldDisplayError';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

const File = ({
  customFileName,
  disabled = false,
  formats,
  id,
  instructions,
  label,
  name,
  onChange,
  validate = {},
  wrapperProps,
}) => {
  const { setFieldValue } = useFormikContext();
  const { required } = validate;

  const handleValidate = useCallback(
    (value) => {
      if (required) {
        return validateRequired(value);
      }
    },
    [required],
  );

  const handleChange = useCallback(
    (file) => {
      setFieldValue(name, file);
      onChange?.(file);
    },
    [name, onChange, setFieldValue],
  );

  return (
    <Box mb={6} {...wrapperProps} display="block" width="100%">
      <Field name={name} validate={handleValidate}>
        {({ field, meta, form }) => (
          <FileInput
            {...field}
            customFileName={customFileName}
            dataTestId="formik-file"
            disabled={disabled}
            error={shouldDisplayError({ meta, form })}
            formats={formats}
            instructions={instructions}
            id={id || name}
            initialValue={meta.initialValue}
            label={label}
            onChange={handleChange}
            touched={meta.touched}
            required={required}
          />
        )}
      </Field>
    </Box>
  );
};

File.propTypes = {
  customFileName: PropTypes.string,
  disabled: PropTypes.bool,
  formats: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  id: PropTypes.string,
  instructions: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  validate: PropTypes.shape({
    required: PropTypes.bool,
  }),
  wrapperProps: PropTypes.object,
};

export default File;
